
import { gql } from '@apollo/client';
import { venueFragment } from '../fragments';

export const READ_POHODA_CENTRE_ID = gql`
  fragment VenuesWithPohodaCentreIdFragment on Venue {
      pohodaCentreId
  }
`;

export const INIT = gql`
    query GetInitInfo{
        venues {
            ...VenuesFragment
            pohodaCentreId
            dueDate
            debt
        }
        employeePermissions{
            warehouse
            backoffice
        }
    }
    ${venueFragment}
`;